module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.127ff58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/title-banner1-type3.png
// module id = eziC
// module chunks = 1